export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00442.34c5795f.png";